import React from "react";

const InfoIcon = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4167 10.75H13.5833V7.91665H16.4167M16.4167 22.0833H13.5833V13.5833H16.4167M15 0.833313C13.1396 0.833313 11.2974 1.19974 9.57865 1.91169C7.85987 2.62363 6.29815 3.66714 4.98266 4.98263C2.32589 7.6394 0.833336 11.2427 0.833336 15C0.833336 18.7572 2.32589 22.3606 4.98266 25.0173C6.29815 26.3328 7.85987 27.3763 9.57865 28.0883C11.2974 28.8002 13.1396 29.1666 15 29.1666C18.7572 29.1666 22.3606 27.6741 25.0173 25.0173C27.6741 22.3606 29.1667 18.7572 29.1667 15C29.1667 13.1396 28.8002 11.2974 28.0883 9.57863C27.3764 7.85985 26.3328 6.29813 25.0173 4.98263C23.7019 3.66714 22.1401 2.62363 20.4214 1.91169C18.7026 1.19974 16.8604 0.833313 15 0.833313Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default InfoIcon;
